import { type PropsWithChildren, type Ref } from 'react'
import { Stack } from '@mui/material'

type Props = PropsWithChildren & {
  /**
   * Remove the side padding on Content
   * @default false
   */
  noPaddingSides?: boolean
  /**
   * Ref forwarded to the scroll container. Useful for resetting `scrollTop`
   * when navigating between views inside the same Modal.
   */
  ref?: Ref<HTMLDivElement>
}

export const ModalContent = ({ children, noPaddingSides = false, ref }: Props) => (
  <Stack
    ref={ref}
    className={['DhlModal-content', ...(noPaddingSides ? ['no-side-padding'] : [])].join(' ')}
    sx={{ display: 'flex', flex: 1, overflow: 'auto' }}
  >
    {children}
  </Stack>
)
